

<template>
  <div class="top-bar">
    <div class="nav-back" @click="goBack">
      <svg class="icon" viewBox="0 0 1024 1024" width="0.48rem" height="0.48rem">
        <path d="M682.667 874.667 320 512l362.667-362.667 59.733 59.734L443.733 512l298.667 298.667z" fill="#333"/>
      </svg>
    </div>
    <div class="nav-title">{{ title }}</div>
    <div class="nav-placeholder">
      <span v-if="showEdit" @click="toEdit">{{ rightTxt }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    rightTxt: {
      type: String,
      default: 'edit'
    }
  },
  data() {
    return {

    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    toEdit(){
      this.$emit('toEdit')
      // this.$router.push({
      //   path: '/ph/compare/edit'
      // })
    },
  }
}
</script>

<style scoped>
/* 顶部导航栏 */
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1rem;
  padding: 0 0.32rem;
  background: #fff;
}

.nav-back,
.nav-placeholder {
  width: 1.5rem;
  text-align: right;

}

.nav-placeholder {
  font-size: .26rem;
  vertical-align: bottom;
}

.nav-title {
  font-size: 0.36rem;
  font-weight: 600;
  color: #333;
}

.icon {
  display: block;
}

</style>